'use strict';

var React = require('react');
var index_esm = require('../../node_modules/react-youtube/dist/index.esm.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function FeaturedVideo(_ref) {
  var videoId = _ref.videoId;
  return React__default["default"].createElement(index_esm, {
    videoId: videoId,
    opts: {
      width: '100%'
    }
  });
}

module.exports = FeaturedVideo;
